import './competency-card.scss';
import { useHistory } from 'react-router-dom'
import React from "react";
import {CompetencyTestType} from "../../../typings/competency-test";
import { Badge } from "../../UI/Badge";
const CompetencyCard: React.FC<CompetencyTestType> = (props: CompetencyTestType) => {
	const history = useHistory();
	const detail = (id: number) => {
		history.push(`/competency/${id}`)
	}

	const MyCardInfo = () => {
		if(props?.isExpired){
			return (<div className="inline-block px-2 py-1 text-xs font-medium rounded bg-red-500" style={{whiteSpace: 'normal'}}>Tes ini sudah kadaluarsa</div>)
		}else if(props?.isOnProgress){
			return (<div className="inline-block px-2 py-1 text-xs font-medium rounded bg-blue-500" style={{whiteSpace: 'normal'}}>Anda masih mengerjakan test ini</div>)
		}else{
			return (
				<div className="flex items-center" style={{ gap: '16px' }}>
					<span>Nilai:</span>
					<span className="font-bold text-5xl">{props.score ?? 0}</span>
				</div>
			)
		}
	}

	return (
    <div
      className="card-course rounded-lg bg-white cursor-pointer relative text-card-foreground shadow-sm"
      onClick={() => detail(props.id)}
    >
      {props?.label && (
        <div className="absolute top-2 right-2">
          <Badge
            variant="outline"
            className={`bg-accent/10 text-accent border-accent/20`}
          >
            <span className="ml-1">{props?.label}</span>
          </Badge>
        </div>
      )}
      <div className={`cc-content ${props?.label ? "pt-6" : ""}`}>
        <div className="cc-image">
          <img
            src={props?.image ?? "https://placehold.co/300x300"}
            alt={"logo"}
          />
        </div>
        <div className="cc-content-info w-full">
          <h5 className="font-bold mb-3 mt-1">
            {props.title}
          </h5>
          {props?.isMy ? (
            <MyCardInfo />
          ) : (
            <div className="flex flex-wrap gap-2">
              <Badge
                variant="outline"
                className={`bg-accent/10 text-accent border-accent/20`}
              >
                <span className="ml-1">{props.duration} Menit</span>
              </Badge>
              <Badge
                variant="outline"
                className={`bg-warning/10 text-warning border-warning/20`}
              >
                <span className="ml-1">{props.totalQuestions} Pertanyaan</span>
              </Badge>
              {props?.totalUsers && props.totalUsers > 0 ? (
                <>
                  <Badge
                    variant="outline"
                    className={`bg-primary/10 text-primary border-primary/20`}
                  >
                    <span className="ml-1">{props?.totalUsers} Peserta</span>
                  </Badge>
                </>
              ):null}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
export default CompetencyCard;
